import { initialFormState } from '../../../../subcomponents/form/form/types/state';
import { defaultTicketRedemptionCodeFormData } from './data';
export const defaultTicketRedemptionCodeFormState = Object.assign(Object.assign({}, initialFormState), { formData: defaultTicketRedemptionCodeFormData, hasTypeBeenManuallySet: false });
